import { getIsCypressOnLocalhost } from '@sureapp/platform-sdk';

import { featureFlag } from '@@/auto/constants/featureFlags';
import { useFeatureFlags } from '@@/common/services/useFeatureFlags';

function useRecaptcha(vertical: 'farmers_renters' | 'toggle_auto') {
  const { isFeatureEnabled } = useFeatureFlags();

  const isRecaptchaEnabled = isFeatureEnabled(featureFlag.IS_RECAPTCHA_ENABLED);
  const isAutoHCaptchaEnabled = isFeatureEnabled(
    featureFlag.IS_AUTO_HCAPTCHA_ENABLED
  );
  const isRentersHCaptchaEnabled = isFeatureEnabled(
    featureFlag.IS_RENTERS_HCAPTCHA_ENABLED
  );

  const isHCaptchaEnabled =
    (isRentersHCaptchaEnabled && vertical === 'farmers_renters') ||
    (isAutoHCaptchaEnabled && vertical === 'toggle_auto');

  function recaptcha() {
    if (isRecaptchaEnabled) {
      return new Promise((resolve, reject) => {
        if (getIsCypressOnLocalhost()) {
          resolve('CAP_TOK');
        }

        const grecaptcha = window?.grecaptcha || null;
        if (!grecaptcha) {
          reject();
        }
        window.grecaptcha.enterprise.ready(async () => {
          const token = await window.grecaptcha.enterprise.execute(
            process.env.REACT_APP_CAPTCHA_SITE_KEY!
          );
          resolve(token);
          // IMPORTANT: The 'token' that results from execute is an encrypted response sent by
          // reCAPTCHA Enterprise to the end user's browser.
          // This token must be validated by creating an assessment.
          // See https://cloud.google.com/recaptcha-enterprise/docs/create-assessment
        });
      });
    }
    if (isHCaptchaEnabled) {
      return new Promise((resolve, reject) => {
        if (getIsCypressOnLocalhost()) {
          resolve('CAP_TOK');
        }
        if (!window.hcaptcha) {
          resolve('WINDOW_HCAPTCHA_UNDEFINED');
        }
        window.hcaptcha
          .execute({ async: true })
          .then(({ response }) => {
            resolve(response);
          })
          .catch((err) => {
            console.error(err);
            reject(err);
          });
      });
    }
    return new Promise((resolve) => {
      resolve(null);
    });
  }

  return { recaptcha };
}

export default useRecaptcha;
